import { BooleanInput, Create, CreateContextProvider, Form, required, SaveButton, SelectInput, TextInput, Toolbar, TopToolbar, useCreateController, useNotify, useRedirect, useTranslate } from 'react-admin';
import { Box, Card, Divider, Stack, Typography, Button as MUIButton } from '@mui/material';

import CustomTagInput from 'src/pages/admin/components/CustomTagInput';
import { chains } from 'src/assets/data';

interface FormProps {
  isCreate: boolean;
}
const CategoryForm = (props: FormProps) => {
    const { isCreate } = props;
    const t = useTranslate();

    return (
        <><Stack spacing={3} gap={2}>
            <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} spacing={2} mb={1}>
                <Typography
                    variant="body2"
                    sx={{ flexBasis: '20%', flexShrink: 0 }}
                >
                    {t("module.categories.name")}
                </Typography>
                <Box sx={{ flexGrow: 1 }}>
                    <TextInput
                        label=""
                        source="name"
                        disabled={!isCreate}
                        alwaysOn
                        fullWidth
                        placeholder={t("module.categories.name")}
                        helperText={<span style={{ color: 'red' }}>{""}</span>}
                        validate={[
                            required()
                        ]} />
                </Box>
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} spacing={2} mb={1}>
                <Typography
                    variant="body2"
                    sx={{ flexBasis: '20%', flexShrink: 0 }}
                >
                    {t("module.categories.chain")}
                </Typography>
                <Box
                    sx={{ flexGrow: 1 }}
                >
                    <SelectInput
                        label=''
                        source="chainId"
                        disabled={!isCreate}
                        defaultValue={501424}
                        validate={[required()]}
                        fullWidth
                        helperText={<span style={{ color: 'red' }}></span>}
                        // sx={{
                        //   pointerEvents: !isCreate ? 'none' : 'auto',
                        // }}
                        choices={chains} />
                </Box>

            </Stack>
            <Stack direction={'row'} alignItems={'center'} spacing={2} mb={1}>
                <Typography
                    variant="body2"
                    sx={{ flexBasis: '20%', flexShrink: 0 }}
                >
                    {t("module.categories.enable")}
                </Typography>
                <Box
                    sx={{ flexGrow: 1 }}
                >
                    <BooleanInput label='' source="isEnable" helperText={<span style={{ color: 'red' }}>{""}</span>} />
                </Box>

            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} spacing={2} mb={1}>
                <Typography
                    variant="body2"
                    sx={{ flexBasis: '20%', flexShrink: 0 }}
                >
                    {t("module.categories.keywords")}
                </Typography>
                <Box
                    sx={{ flexGrow: 1 }}
                >
                    <CustomTagInput source="keywords" label={t("module.categories.keywords")} />
                </Box>

            </Stack>
        </Stack></>
    );
};

export default CategoryForm;
